


export enum ComponentInteractionPositionEnum {
    TOP = 'TOP',
    CENTER = 'CENTER',
    BOTTOM = 'BOTTOM',
  
}